import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the EnterpriseTermPublished EC, used to pick the Enterprise Term a Rule
// governs. Display = the term's Name; value = EnterpriseTermUSID (the LOGICAL term, not a revision)
// so the association survives every revise on that end.
//
// Only PUBLISHED terms are listed: a rule-term association resolves for display through the term's
// last published revision, so a draft-only term would show as a blank row. The server rejects one
// outright (CC-RTRM-NPUB); this keeps it off the menu.
class EnterpriseTermPublishedPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "EnterpriseTermPublished";
        this.static = false;
        this.enterpriseComponent = "EnterpriseTermPublished";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "EnterpriseTermUSID";
        this.allowNoSelection = false;
        // A GLOSSARY IS LONG. Loading every released term to filter in the browser is a large payload
        // before anybody has typed, and a hard cap past which a term cannot be chosen at all. Used with
        // the "ComboBox" control, this asks the server for the names containing what was typed.
        this.serverFilter = true;
        this.serverFilterOperator = "Contains";
        this.serverFilterLimit = 25;
        // The link stores a term USID, so free text is never a value.
        this.mustMatchOption = true;
        // UNDER THE ACTIVE PERSONA, like every list and like the business process term picker. Without it
        // the request carried no persona and offered every released term in the realm, so the two pickers
        // disagreed about what somebody could choose.
        this.visibilityType = "Persona";
    }
}

export default EnterpriseTermPublishedPicklistMetadata;
